<div class="score-base-container">
  <div class="header">
    <div class="icon" cygovSvgIcon [svgName]="'shield-hollow'"></div>
    <h2 class="title lato-18-n-vw">Scoring Base</h2>
  </div>
  <div class="scoring-base-options">
    @for (option of scoringBaseOptions; track option.value) {
    <div class="type-radio round-checkbox" (click)="scoringBaseChangeHandler($event, option)"
      [class.checked]="option.checked">
      <div class="radio-outer-circle" [ngClass]="{'checked': option.checked}">
        <div class="radio-inner-circle"></div>
      </div>
      <div class="radio-label lato-16-n-vw">{{option.name}}</div>
    </div>
    }
  </div>
</div>